import React, { useState } from 'react';
import './Contact.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    website: '',
  });
  const [isSending, setIsSending] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });
  const [formStartedAt] = useState(Date.now());

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus({ type: '', message: '' });
    setIsSending(true);

    try {
      const normalizedEmail = formData.email.trim().toLowerCase();
      const cooldownKey = `contactCooldown:${normalizedEmail}`;
      const lastSentAt = Number(localStorage.getItem(cooldownKey) || 0);
      const cooldownMs = 120000;
      const now = Date.now();

      if (lastSentAt && now - lastSentAt < cooldownMs) {
        const seconds = Math.ceil((cooldownMs - (now - lastSentAt)) / 1000);
        throw new Error(`Espera ${seconds}s antes de volver a enviar.`);
      }

      const response = await fetch(`${API_BASE_URL}/api/mensajes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nombre: formData.name.trim(),
          email: normalizedEmail,
          mensaje: formData.message.trim(),
          website: formData.website.trim(),
          formStartedAt,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.message || 'No se pudo enviar el mensaje');
      }

      setStatus({
        type: 'success',
        message: data.message || 'Mensaje enviado correctamente.',
      });
      localStorage.setItem(cooldownKey, String(now));
      setFormData({ name: '', email: '', message: '', website: '' });
    } catch (error) {
      setStatus({
        type: 'error',
        message: error.message || 'Error al conectar con el servidor.',
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <h2>Hablemos de tu proyecto</h2>
      <p>Si quieres desarrollar una solución web o mejorar una plataforma existente, conversemos.</p>
      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="website"
          className="hp-field"
          tabIndex="-1"
          autoComplete="off"
          value={formData.website}
          onChange={handleChange}
        />
        <input
          type="text"
          name="name"
          placeholder="Tu nombre"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Tu correo"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder="Cuéntame sobre tu proyecto"
          rows="7"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
        <button type="submit" className="submit-button" disabled={isSending}>
          {isSending ? 'Enviando...' : 'Enviar mensaje'}
        </button>
        {status.message && (
          <p className={`form-status ${status.type}`} role="status" aria-live="polite">
            {status.message}
          </p>
        )}
      </form>
      <div className="social-links">
        <a href="https://github.com/Duartemario501" target="_blank" rel="noopener noreferrer">GitHub</a>
        <a href="https://www.linkedin.com/in/mario-monteros/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
      </div>
    </section>
  );
};

export default Contact;
